import { ShopChangelogTotals } from '../../types/shopChangelog';

/** Format a buy/sell price value for display. -1 sentinel means "disabled". */
export function formatPrice(raw: unknown): { label: string; tone: 'normal' | 'disabled' | 'unknown' } {
  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return { label: String(raw ?? '—'), tone: 'unknown' };
  }
  if (n === -1) {
    return { label: 'disabled', tone: 'disabled' };
  }
  return { label: `₡${n}`, tone: 'normal' };
}

export interface SummaryToken {
  text: string;
  /** UI tone — drives colour. */
  tone: 'add' | 'remove' | 'modify' | 'rename';
}

/** Compute the comma-separated tokens for a feed-row summary. */
export function summariseTotals(totals: ShopChangelogTotals): SummaryToken[] {
  const out: SummaryToken[] = [];
  const push = (n: number, tone: SummaryToken['tone'], singular: string, plural: string, sign: string) => {
    if (!n) return;
    out.push({ tone, text: `${sign}${n} ${n === 1 ? singular : plural}` });
  };

  push(totals.pagesAdded,      'add',    'page',  'pages',  '+');
  push(totals.pagesRemoved,    'remove', 'page',  'pages',  '−');
  push(totals.pagesRenamed,    'rename', 'page renamed', 'pages renamed', '~');
  push(totals.entriesAdded,    'add',    'entry', 'entries', '+');
  push(totals.entriesRemoved,  'remove', 'entry', 'entries', '−');
  push(totals.entriesModified, 'modify', 'entry modified', 'entries modified', '~');

  return out;
}

/**
 * True if this push contains any destructive change.
 * Used to power the "destructive only" filter chip and a small badge.
 */
export function isDestructive(totals: ShopChangelogTotals): boolean {
  return totals.pagesRemoved > 0 || totals.entriesRemoved > 0;
}
